export default (req) => ({
  login: (email, password) =>
    req.post("/auth/login", { Email: email, Password: password }),
  refreshToken: (refreshToken) =>
    req.post("/auth/refreshoken", { RefreshToken: refreshToken }),
});
